import styled from "styled-components"
import PRIMARY from "../../../style/colors"

export const Container = styled.div`
    width: 100%;
    line-height: 24px;
`

export const Section = styled.div`
    margin-top: 30px;
`
export const JustifySection = styled.div`
    margin-top: 30px;
    text-align: justify;
    text-justify: inter-word;
`
export const JustifySectionAr = styled.div`
    margin-top: 30px;
    font-size:20px;
    text-align: justify;
    text-justify: inter-word;
    letter-spacing: 1px;
    word-spacing: 1px;
    line-height: 30px;
`

export const SubTitle = styled.h3`
    color: ${PRIMARY};
    margin-top: 0px;
    margin-bottom: 10px;
    font-size: 20px;
    font-family: Montserratmedium;
`

export const SubTitleAr = styled.h3`
    color: ${PRIMARY};
    margin-top: 0px;
    margin-bottom: 10px;
    font-size: 24px;
    font-family: Montserratmedium;
`

export const BlackSubTitle = styled.h4`
    font-style: italic;
    font-size: 18px;
    font-family: Montserratmedium;
`

// export const RedSpan = styled.span`
//     color: ${PRIMARY};
//     font-style: bold;
// `

export const RedSpan = styled.span`
    font-weight: 700;
`

export const DateSpan = styled.span`
    font-size: 18px;
`
